module.exports = __webpack_public_path__ + "static/media/Calendar.459ae48e.svg";